<template>
    <div>
        <!-- 앱 예약 활성화 -->
        <AppReservationActive
            v-model="column.isActive"
        />
        <!-- 고객 직접 예약 제한 -->
        <AppReservationDayBlock
            :isActive="column.isActive"
            :sameDayBlockDuration="column.sameDayBlockDuration"
            :sameDayBlockType="column.sameDayBlockType"
            :possibleCreateRange="column.possibleCreateRange"
            @updateValue="handleUpdateValue"
        />
        <!-- 고객 직접 예약 변경 -->
        <AppReservationByUser
            :isActive="column.isActive"
            :canModify="column.canModify"
            :canModifyType="column.canModifyType"
            :possibleModifyRange="column.possibleModifyRange"
            @updateValue="handleUpdateValue"
        />
        <!-- 고객 직접 예약 취소 -->
        <AppReservationCancelByUser
            :isActive="column.isActive"
            :canCancel="column.canCancel"
            :canCancelType="column.canCancelType"
            :possibleCancelRange="column.possibleCancelRange"
            @updateValue="handleUpdateValue"
        />
        <!-- 앱 예약 시간 간격 -->
        <AppReservationInterval
            :isActive="column.isActive"
            :usingDefaultAppInterval="column.usingDefaultAppInterval"
            :appInterval="column.appInterval"
            :appTimeIntervals="column.appTimeIntervals"
            :isErrorAppInterval="isErrorAppInterval"
            :isErrorDuplicatedAppInterval="isErrorDuplicatedAppInterval"
            @updateValue="handleUpdateValue"
            @clearError="handleClearError"
        />
        <!-- 앱 시간당 예약 인원 -->
        <AppReservationCapacity
            :isActive="column.isActive"
            :appMaxCapacity="column.appMaxCapacity"
            @updateValue="handleUpdateValue"
        />
    </div>
</template>
<script>
import AppReservationActive from './Components/AppReservationActive.vue'
import AppReservationDayBlock from './Components/AppReservationDayBlock.vue'
import AppReservationByUser from './Components/AppReservationByUser.vue'
import AppReservationCancelByUser from './Components/AppReservationCancelByUser.vue'
import AppReservationInterval from './Components/AppReservationInterval.vue'
import AppReservationCapacity from './Components/AppReservationCapacity.vue'

export default {
    props: {
        column: Object,

        isErrorAppInterval: Boolean,
        isErrorDuplicatedAppInterval: Boolean
    },
    components: {
        AppReservationCapacity, AppReservationInterval, AppReservationCancelByUser,
        AppReservationByUser, AppReservationActive, AppReservationDayBlock
    },
    methods: {
        handleClearError(errorName) {
            this.$emit('clearError', errorName)
        },
        handleUpdateValue(data) {
            this.$emit('updateValue', data)
        }
    }
}

</script>